import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { API, graphqlOperation, Storage } from 'aws-amplify';

import Layout from '../../components/Layout';
import { ClassicBanner } from '../../components/Banner';
import { LoadingSpinner } from '../../components/LoadingSpinner';

import { CreateBannerData } from './create-banner-data';
import { useUser, userInfo } from '../../contexts/user';
import { createWall } from '../../graphql/mutations';
import CarouselBanner from '../../components/Banner/CarouselBanner/carousel-banner';

const CreateWallPage = () => {
    const { occasion, layout } = useParams();
    const history = useHistory();
    const { user, identityId } = useUser();

    const [isModalActive, setIsModalActive] = useState(false);

    React.useEffect(() => {
        const validate = () => {
            if (occasion !== 'birthday') {
                history.push('/create');
            }
            if (!['classic', 'carousel'].includes(layout)) {
                history.push(`/create/${occasion}`);
            }
        }

        validate()

    }, [occasion, layout, history]);

    const onNewWall = async (data) => {
        setIsModalActive(true)

        const { userId, userName } = userInfo(user)
        const config = JSON.stringify({...data.config, "s3IdentityId": identityId})
        const input = {
            status: 'OPEN',
            senderId: userId,
            senderName: userName,
            layout: data.layout,
            config: config,
            occasion: occasion,
            createdAt: new Date().toISOString(),
            greetingType: 'fb-comments'
        }

        if (data.images) {
            await data.images.forEach(image => {
                const { file, s3Key } = image
                Storage.put(s3Key, file, { level: 'protected' })
            })
        }

        const result = await API.graphql(graphqlOperation(createWall, { input })).finally(() => {
            setIsModalActive(false)
            history.push('/');
        })

        console.info(`Created wall: id ${result.data.createWall.id}`)
    }


    const banner = () => {
        switch (layout) {
            case 'classic':
                return <ClassicBanner
                    readonly={false}
                    showEditorOnOpen={true}
                    heroClassName="is-medium"
                    data={CreateBannerData.classic}
                    onChange={(c) => { onNewWall(c) }}
                />
            case 'carousel':
                return <CarouselBanner
                    readonly={false}
                    showEditorOnOpen={true}
                    heroClassName="is-medium"
                    data={CreateBannerData.carousel}
                    onChange={(c) => { onNewWall(c) }}
                />
            default:
                return '<div></div>'
        }
    }


    return (
        <Layout>

            <section className='hero is-bold'>
                <div className='hero-body'>

                </div>
            </section>
            <div id="container">
                <div className='columns is-centered'>
                    <main className="main column is-paddingless">
                        {banner()}
                    </main>
                </div>
            </div>
            <div className={`modal ${isModalActive ? `is-active` : ''}`}>
                <div className="modal-background"></div>
                <div className="modal-content is-clipped py-6 has-background-white" >
                    <LoadingSpinner message="Please wait..." messageClassName='has-text-grey title' />
                </div>
            </div>

            <section className='hero is-bold'>
                <div className='hero-body'>

                </div>
            </section>

        </Layout>
    );
}

export default CreateWallPage;